// extracted by mini-css-extract-plugin
export default {"container_butons":"dados_abertos_container_butons__rvv8k","button_rotes":"dados_abertos_button_rotes__7AC3B","acoes":"dados_abertos_acoes__iWyyQ"};